'use client';
import { useDialog } from '@svs/nova-foundation/nextjs/dialog';
import { type ReactNode, useEffect, useRef } from 'react';

/**
 * Displays a message indicating that the draw is closed.
 *
 * @returns A message informing the user that the draw is closed.
 */
export default function DrawClosedHandler(): ReactNode {
  const shouldShowDialog = useRef(true);
  const { showDialog } = useDialog();

  useEffect(() => {
    if (shouldShowDialog.current) {
      // Fire & forget – no awaiting
      void showDialog({
        type: 'info',
        title: 'Omgången är stängd',
        description: 'Välj en annan omgång eller välkommen tillbaka när spelet öppnar igen.',
        buttons: {
          primary: { label: 'Ok' },
        },
      });

      shouldShowDialog.current = false;
    }
  }, [showDialog]);

  return undefined;
}
